import React from 'react'
import styled from 'styled-components'

type LayoutTypes = {
    className?: string,
    bottomBar: JSX.Element
    topLeftBar: JSX.Element
    topRightBar: JSX.Element
}

function LayoutTablet(props: LayoutTypes) {


    return (
        <StyledLayout className={props.className}>
            <div className='main'>
                <div className='top'>
                    <div className='top-left__bar'>{props.topLeftBar}</div>
                    <div className='top-right__bar'>{props.topRightBar}</div>
                </div>
                <div className='bottom'>
                    {props.bottomBar}
                </div>
            </div>
        </StyledLayout>
    )
}


const StyledLayout = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  justify-content: center;

  .main {
    height: 100%;
    width: 95%;
    display: flex;
    flex-direction: column !important;

    .top {
      display: flex;
      width: 100%;
      justify-content: space-between;

      .top-left__bar {
        display: flex;
        flex-direction: column;
        width: 40%;
      }

      .top-right__bar {
        display: flex;
        flex-direction: column;
        width: 57%;

      }
    }

    .bottom {
      width: 100%;
      display: flex;
      flex-direction: column;
    }


  }

`
export default LayoutTablet